import { useCallback, useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
// import {
//   type Location,
//   useLocation as useCompatLocation,
//   useParams as useCompatParams,
// } from 'react-router-dom-v5-compat';

// import { useHistory as useLegacyHistory } from 'react-router-dom';

export {
  BrowserRouter,
  Redirect,
  Prompt,
  type LinkProps,
  MemoryRouter,
  Route,
  Switch,
  Link,
  NavLink,
  useParams,
  useLocation,
  useHistory,
  useRouteMatch,
  matchPath,
  generatePath,
} from 'react-router-dom';

export {
  CompatRouter,
  // Link,
  // NavLink,
} from 'react-router-dom-v5-compat';

// export const useParams = <
//   Params extends { [K in keyof Params]?: string } = {},
// >(): Params => {
//   return useCompatParams() as unknown as Params;
// };
//
// export const useLocation = <
//   Params extends { [key: string]: unknown } = {},
// >(): Location<Params | undefined> => {
//   return useCompatLocation() as Location<Params | undefined>;
// };

// // @ts-expect-error post upgrade will be updated
// export const useHistory: typeof useLegacyHistory = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//
//   return {
//     push: (path: string, state?: any) => navigate(path, { state }),
//     replace: (path: string, state?: any) =>
//       navigate(path, { replace: true, state }),
//     go: (n: number) => window.history.go(n),
//     goBack: () => window.history.back(),
//     goForward: () => window.history.forward(),
//     location, // Mimic `history.location`
//   };
// };

// This hook is useful only if you within /company/:id/app/:id/ url space
export const useAppLocation = () => {
  const location = useLocation();

  const matchAppPath = useCallback((pathname: string) => {
    const basePath = '/company/:companyKey/app/:appKey/*';
    const opts = { path: basePath };
    return matchPath<{ '0'?: string }>(pathname, opts)?.params['0'];
  }, []);

  const currentUrl = location.pathname + location.search + location.hash;
  const matchedAppPath = matchAppPath(currentUrl);
  const appUrl = matchedAppPath ? `/${matchedAppPath}` : undefined;

  return useMemo(
    () => ({
      appUrl,
    }),
    [appUrl]
  );
};
